const config = {
  emailConfig: {
    service_id: "service_njuw8ak",
    template_id: "template_qbdufh5",
    public_key: "oJqwDSlwEIIBumhyC",
  },
};

export default config;
